import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import ApolloThemeProvider from 'apollo-react/utils/ApolloThemeProvider';
import App from './App';
import 'react-toastify/dist/ReactToastify.css';
// import { AuthProvider } from "./Contexts/Auth.js";


const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <ApolloThemeProvider themeName="IDS">
    <React.StrictMode>
      <Router>
        {/* <AuthProvider> */}
          <App />
        {/* </AuthProvider> */}
      </Router>
    </React.StrictMode>
  </ApolloThemeProvider>
);